module.exports = __webpack_public_path__ + "static/media/rebirth_5.ba125209.jpg";